"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerTimer = void 0;
var vue_1 = require("vue");
var Timer_1 = require("../../Timer");
exports.PlayerTimer = vue_1.default.component('player-timer', {
    props: {
        timer: {
            type: Object,
        },
    },
    data: function () {
        return {
            timerText: '',
        };
    },
    mounted: function () {
        this.updateTimer();
    },
    watch: {
        timerText: {
            handler: function () {
                var _this = this;
                setTimeout(function () {
                    _this.updateTimer();
                }, 1000);
            },
        },
    },
    methods: {
        updateTimer: function () {
            this.timerText = Timer_1.Timer.toString(this.timer);
        },
        hasHours: function () {
            if (this.timerText.split(':').length > 2) {
                return 1;
            }
            return 0;
        },
        getHours: function () {
            if (this.hasHours()) {
                return this.timerText.split(':')[0];
            }
            return '';
        },
        getMinutes: function () {
            if (this.hasHours()) {
                return this.timerText.split(':')[1];
            }
            return this.timerText.split(':')[0];
        },
        getSeconds: function () {
            if (this.hasHours()) {
                return this.timerText.split(':')[2];
            }
            return this.timerText.split(':')[1];
        },
    },
    template: "\n    <div class=\"player-timer\">\n      <template v-if=\"hasHours()\">\n         <div class=\"player-timer-hours time-part\">{{ getHours() }}</div>\n         <div class=\"timer-delimiter\">:</div>\n      </template>   \n      <div class=\"player-timer-minutes time-part\">{{ getMinutes() }}</div>\n      <div class=\"timer-delimiter\">:</div>\n      <div class=\"player-timer-seconds time-part\">{{ getSeconds() }}</div>\n    </div>\n  ",
});
//# sourceMappingURL=PlayerTimer.js.map